import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { urls } from './../../../../environments/environment';

@Injectable()
export class ContaService {

  constructor(
    private http: HttpClient
  ) { }

  atualizarConta(data) {
    if (data.InformacoesBancarias && data.InformacoesBancarias) {
      data.InformacoesBancarias.forEach(item => {
        if (item.InformacaoBancariaId === '') {
          delete item.InformacaoBancariaId;
        }
      });
    }
    return this.http
      .put(urls.apiBase + '/Contas/Atualizar', data);
  }

  obterConta(id) {
    return this.http
      .get(urls.apiBase + '/Contas/ObterPorId?id=' + id);
  }

  adicionarLogo(data, id) {
    return this.http
      .post(urls.apiBase + '/Contas/AdicionarLogo?id=' + id, data);
  }

  removerLogo(id) {
    return this.http
      .put(urls.apiBase + '/Contas/RemoverLogo?contaid=' + id, null);
  }

  resultadosDoCiclo(id) {
    return this.http
      .get(urls.apiBase + '/Contas/ObterStatusCicloAtual?id=' + id);
  }

  adicionarDocumento(data, id) {
    return this.http
      .post(urls.apiBase + '/Contas/AdicionarDocumento?contaId=' + id, data);
  }

  criarConta(id) {
    return this.http
      .post(urls.apiBase + '/Contas/AdicionarConta?contaId=' + id, {});
  }

  obterClientes(contaId) {
    return this.http
      .get(urls.apiBase + '/Contas/ObterClientes?contaId=' + contaId);
  }

  obterClienteDetalhado(contaId, clienteId) {
    return this.http
      .get(urls.apiBase + '/Contas/ObterClienteDetalhado?contaId=' + contaId + '&clienteId=' + clienteId);
  }

  obterFaturamentoPorPessoaId(pessoaId: string) {
    return this.http
      .get(urls.apiBaseActuar + '/Faturamento/ObterPorPessoaId?PessoaId=' + pessoaId);
  }

  vincularCartao(data: any) {
    return this.http
      .post(`${urls.apiBaseActuar}/Faturamento/VincularCartao`, data , {
        withCredentials: false
      });
  }

  obterFaturasPorPessoaId(pessoaId: string) {
    return this.http
      .get(urls.apiBaseActuar + '/Faturas/ObterTodosPorPessoaId?pessoaId=' + pessoaId);
  }

  getUserInfo(id: string) {
    return this.http
      .get(urls.identity + '/User/GetInfo/' + id);
  }
}
